namespace RioERP.Orders {
    export namespace FranchiseeOrdersService {
        export const baseUrl = 'Orders/FranchiseeOrders';

        export declare function Create(request: Serenity.SaveRequest<FranchiseeOrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FranchiseeOrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FranchiseeOrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveFranchisee(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Users.FranchiseeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FranchiseeOrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/FranchiseeOrders/Create",
            Update = "Orders/FranchiseeOrders/Update",
            Delete = "Orders/FranchiseeOrders/Delete",
            Retrieve = "Orders/FranchiseeOrders/Retrieve",
            RetrieveFranchisee = "Orders/FranchiseeOrders/RetrieveFranchisee",
            List = "Orders/FranchiseeOrders/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'RetrieveFranchisee', 
            'List'
        ].forEach(x => {
            (<any>FranchiseeOrdersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
